/*! Auric theme core JS — drawers, header behavior, mega menu, accordions */
(function () {
  'use strict';

  var html = document.documentElement;

  /* ---------- Drawer system (mobile menu + cart) ---------- */
  function closeAllDrawers() {
    document.querySelectorAll('[data-drawer].is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-drawer-overlay]').forEach(function (el) {
      el.classList.remove('is-open');
      el.hidden = true;
    });
    html.classList.remove('drawer-open');
  }

  function openDrawer(name) {
    closeAllDrawers();
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    var overlay = drawer ? drawer.previousElementSibling : null;
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      var focusable = drawer.querySelector('button, a, input');
      if (focusable) focusable.focus({ preventScroll: true });
    }
    if (overlay && overlay.hasAttribute('data-drawer-overlay')) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    }
    html.classList.add('drawer-open');
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      openDrawer(openTrigger.getAttribute('data-drawer-open'));
      return;
    }
    var closeTrigger = e.target.closest('[data-drawer-close]');
    if (closeTrigger) { closeAllDrawers(); return; }
    if (e.target.hasAttribute('data-drawer-overlay')) { closeAllDrawers(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllDrawers(); closeSearch(); }
  });

  /* ---------- Search overlay ---------- */
  function openSearch() {
    var overlay = document.getElementById('SearchOverlay');
    if (!overlay) return;
    overlay.classList.add('is-open');
    var input = overlay.querySelector('[data-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 100);
  }
  function closeSearch() {
    var overlay = document.getElementById('SearchOverlay');
    if (overlay) overlay.classList.remove('is-open');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { openSearch(); }
    if (e.target.closest('[data-search-close]')) { closeSearch(); }
  });

  /* ---------- Sticky header show/hide on scroll ---------- */
  var header = document.getElementById('SiteHeader');
  if (header) {
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var y = window.scrollY;
          header.classList.toggle('is-scrolled', y > 8);
          if (y > lastY && y > header.offsetHeight * 2) {
            header.classList.add('is-hidden');
          } else {
            header.classList.remove('is-hidden');
          }
          lastY = y;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- Mega menu (hover + keyboard) ---------- */
  document.querySelectorAll('[data-nav-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-nav-trigger]');
    if (!trigger) return;
    var open = function () { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };
    var close = function () { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    trigger.addEventListener('focus', open);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      item.classList.contains('is-open') ? close() : open();
    });
  });

  /* ---------- Generic accordion (mobile drawer, product accordions) ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var panel = trigger.nextElementSibling;
    var isOpen = panel.classList.contains('is-open');
    panel.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });

  /* ---------- Product page accordion (accordion__trigger) ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    var panel = trigger.nextElementSibling;
    var isOpen = panel.classList.contains('is-open');
    document.querySelectorAll('.accordion__panel.is-open').forEach(function (p) {
      if (p !== panel) { p.classList.remove('is-open'); }
    });
    panel.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });

  /* ---------- Facet (filter) accordions ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.facet__trigger');
    if (!trigger) return;
    var panel = trigger.nextElementSibling;
    panel.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(panel.classList.contains('is-open')));
  });

  /* ---------- Lazy image fade-in ---------- */
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    if (img.complete) { img.classList.add('is-loaded'); }
    else { img.addEventListener('load', function () { img.classList.add('is-loaded'); }); }
  });

  /* ---------- Recently viewed (localStorage, in-memory fallback) ---------- */
  window.Auric = window.Auric || {};
  window.Auric.trackRecentlyViewed = function (handle) {
    try {
      var key = 'auric_recently_viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 12);
      localStorage.setItem(key, JSON.stringify(list));
    } catch (err) { /* storage unavailable */ }
  };

  window.Auric.getRecentlyViewed = function () {
    try { return JSON.parse(localStorage.getItem('auric_recently_viewed') || '[]'); }
    catch (err) { return []; }
  };

  /* ---------- Hero / generic slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('.hero-slideshow__track');
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-slide-dot]');
    var index = 0;
    var timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.style.background = di === index ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'; });
    }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }
    function startAutoplay() {
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      if (root.getAttribute('data-autoplay') === 'true' && slides.length > 1) {
        timer = setInterval(next, interval);
      }
    }
    root.querySelector('[data-slide-next]') && root.querySelector('[data-slide-next]').addEventListener('click', function () { clearInterval(timer); next(); startAutoplay(); });
    root.querySelector('[data-slide-prev]') && root.querySelector('[data-slide-prev]').addEventListener('click', function () { clearInterval(timer); prev(); startAutoplay(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { clearInterval(timer); go(di); startAutoplay(); });
    });
    go(0);
    startAutoplay();
  });

  /* ---------- Recently viewed rendering ---------- */
  var rvSection = document.querySelector('[data-recently-viewed]');
  if (rvSection) {
    var handles = window.Auric.getRecentlyViewed();
    var configEl = rvSection.querySelector('[data-recently-viewed-config]');
    var limit = 4;
    try { limit = JSON.parse(configEl.textContent).limit; } catch (e) {}
    handles = handles.slice(0, limit);

    if (handles.length) {
      var grid = rvSection.querySelector('[data-recently-viewed-grid]');
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products.filter(Boolean).forEach(function (p) {
          var price = (p.price / 100).toFixed(2);
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var card = document.createElement('a');
          card.href = p.url;
          card.className = 'product-card';
          card.style.textDecoration = 'none';
          card.innerHTML =
            '<div class="product-card__media aspect-ratio aspect-3-4">' +
              (img ? '<img src="' + img + '&width=800" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">' : '') +
            '</div>' +
            '<p class="product-card__title">' + p.title + '</p>' +
            '<div class="product-card__price"><span>$' + price + '</span></div>';
          grid.appendChild(card);
        });
        if (grid.children.length) rvSection.hidden = false;
      });
    }
  }

  /* Track current product page as "recently viewed" */
  var currentHandle = document.body.getAttribute('data-product-handle');
  if (currentHandle) { window.Auric.trackRecentlyViewed(currentHandle); }

  /* ---------- Product recommendations (native Shopify recommendation API) ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (section) {
    fetch(section.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-recommendations-grid]');
        var grid = section.querySelector('[data-recommendations-grid]');
        if (newGrid && grid && newGrid.children.length) { grid.innerHTML = newGrid.innerHTML; }
      })
      .catch(function () {});
  });
})();
